type Listener = (event: CustomEvent) => void;

// Temporary refactor of ELC.Dispatcher to use native browser events
// Once all references to this are removed from tealium, this file can be deprecated and removed

export default class ElcDispatcher {
  addListener(event: string, callback: Listener): void {
    window.addEventListener(event, callback);
  }

  removeListener(event: string, callback: Listener): void {
    window.removeEventListener(event, callback);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch(event: string, details?: any): void {
    const customEvent = new CustomEvent(event, { detail: details });
    window.dispatchEvent(customEvent);
  }
}
